import { Routes, Route, Navigate } from 'react-router-dom';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Products } from './pages/Products';
import { Contact } from './pages/Contact';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
import TarefasPerto from './pages/TarefasPerto';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/sobre" element={<About />} />
      <Route path="/produtos" element={<Products />} />
      <Route path="/tarefas-perto" element={<TarefasPerto />} />
      <Route path="/contato" element={<Contact />} />
      <Route path="/trabalhe-conosco" element={<Navigate to="/#contato" replace />} />
      <Route path="/termos" element={<Terms />} />
      <Route path="/privacidade" element={<Privacy />} />
    </Routes>
  );
} 